import { MouseEvent } from "react";

import Link from "@whoppah/next/link";

import { analyticsService } from "@/common/services/analytics/analytics.service";
import { cn } from "@/common/utils/css.utils";
import { NewLabel } from "@/ui/cva/NewLabel";
import {
  NavigationMenuItem,
  NavigationMenuLink,
} from "@radix-ui/react-navigation-menu";

type MegaMenuLinkItemProps = {
  href: string;
  label: string;
  badge?: string | null;
  selected?: boolean;
  external?: boolean;
  onSelect?: (evt: Event) => void;
  onClick?: (evt: MouseEvent<HTMLAnchorElement>) => void;
};

export const MegaMenuLinkItem = ({
  href,
  label,
  badge,
  selected,
  external,
  onSelect,
  onClick,
}: MegaMenuLinkItemProps) => {
  const handleClick = (evt: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(evt);

    /** Trigger `navigation_menu` event. */
    analyticsService.trackNavigationMenu(label);
  };

  return (
    <NavigationMenuItem className="flex">
      <NavigationMenuLink
        asChild
        onSelect={onSelect}
        onClick={handleClick}
        className="mega-menu-link"
        title={label}
        target={external ? "_blank" : undefined}
      >
        <Link href={href} prefetch={false}>
          <span
            className={cn(
              "mega-menu-link-label",
              selected && "mega-menu-link-label-selected"
            )}
          >
            {label}
            {/* Inside the label: the link is a grid, a sibling would wrap to its own row. */}
            {badge && (
              <NewLabel className="ml-2 align-middle">{badge}</NewLabel>
            )}
          </span>
        </Link>
      </NavigationMenuLink>
    </NavigationMenuItem>
  );
};
